/**
 * Formatea un número como moneda colombiana (COP)
 * @param value Valor numérico a formatear
 * @returns Cadena formateada como moneda (ej: $1.234.567,89)
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  .format(value)
  .replace(/^\D+/, '')
  .replace(/\s+/, '') // Eliminar el símbolo de moneda y espacios
  .replace(/^/, '$');   // Agregar el signo de peso al inicio
};

/**
 * Convierte una cadena de moneda a un número
 * @param currencyValue Cadena de moneda (ej: $1.234.567,89)
 * @returns Número (ej: 1234567.89)
 */
export const parseCurrency = (currencyValue: string): number => {
  if (!currencyValue) return 0;
  // Eliminar todo excepto números, punto y coma
  const numberString = currencyValue.replace(/[^0-9,.]/g, '');
  // Reemplazar comas por punto para el parseo
  return parseFloat(numberString.replace(/\./g, '').replace(',', '.')) || 0;
};
